import React from 'react';
import {
	List,
	Datagrid,
	TextField,
	Edit,
	Create,
	SimpleForm,
	TextInput,
	Filter,
	DeleteWithConfirmButton,
	useRecordContext,
	required,
} from 'react-admin';
import { Box } from '@mui/material';

// Thèmes (tags) des cas d'usage partenaire.
//
// Table dédiée et pas tags libres : le nom est unique en base, donc renommer un thème le
// renomme sur toutes les fiches qui le portent. Supprimer un thème retire aussi ses liens
// (côté API) — les fiches concernées restent, elles perdent juste ce thème.

// #region ColorSwatch — aperçu de la couleur, à côté de son code
// Un code hexadécimal seul ne dit rien : sans la pastille, l'admin doit ouvrir la fiche
// et deviner à quoi ressemblera le tag côté partenaire.
const ColorSwatch: React.FC<{ label?: string }> = () => {
	const record = useRecordContext();
	const color = (record?.color as string) || '';
	return (
		<Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
			<Box
				sx={{
					width: 16,
					height: 16,
					borderRadius: '4px',
					border: '1px solid rgba(0,0,0,.2)',
					backgroundColor: color || 'transparent',
				}}
			/>
			<span>{color || '—'}</span>
		</Box>
	);
};
// #endregion

const ThemeFilter: React.FC = (props: any) => (
	<Filter {...props}>
		<TextInput source="q" label="Rechercher" alwaysOn />
	</Filter>
);

// #region UseCaseThemeList
export const UseCaseThemeList: React.FC = (props: any) => (
	<List {...props} filters={<ThemeFilter />} sort={{ field: 'name', order: 'ASC' }}>
		<Datagrid rowClick="edit">
			<TextField source="name" label="Thème" />
			<ColorSwatch label="Couleur" />
			{/* Le message dit l'effet de bord : supprimer un thème le retire des fiches
			    qui le portent (les liens partent côté API). Sans ça, la confirmation
			    générique laisse croire qu'on ne touche qu'à une ligne isolée. */}
			<DeleteWithConfirmButton
				confirmTitle="Supprimer ce thème ?"
				confirmContent="Il sera retiré de tous les cas d'usage qui le portent. Les fiches, elles, restent."
			/>
		</Datagrid>
	</List>
);
// #endregion

// #region themeForm
const themeForm = (
	<>
		<TextInput source="name" label="Nom" validate={required()} fullWidth helperText="Unique. Renommer ici renomme le thème sur toutes les fiches." />
		<TextInput source="color" label="Couleur" helperText="Hexadécimal, ex. #7C3AED. Laisser vide pour la couleur par défaut." />
	</>
);
// #endregion

// #region UseCaseThemeEdit
export const UseCaseThemeEdit: React.FC = (props: any) => (
	<Edit {...props}>
		<SimpleForm>{themeForm}</SimpleForm>
	</Edit>
);
// #endregion

// #region UseCaseThemeCreate
// redirect="list" : les thèmes se créent en série avant d'être posés sur les fiches,
// rester sur celui qu'on vient d'écrire coupe l'enchaînement.
export const UseCaseThemeCreate: React.FC = (props: any) => (
	<Create {...props} redirect="list">
		<SimpleForm>{themeForm}</SimpleForm>
	</Create>
);
// #endregion
